var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"cs-icons-notification-filled notification-icon",class:{ 'notification-icon--active': _vm.newNotifications }},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.newNotifications),expression:"newNotifications"}],staticClass:"blue-dot"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }